module.exports = __webpack_public_path__ + "img/BZX60.6347b4d9.jpg";